module.exports = __webpack_public_path__ + "img/Airbnb-Working-Office-Posture-Perfect.a25fb35e.jpg";